<template>
    <v-form ref="form">
        <v-row class="mt-4">
            <v-col cols="4" class="py-0">
                <v-text-field
                    v-model="buscaFilial"
                    class="input-button input-cinza"
                    label="Pesquisar"
                    outlined
                    dense
                    hide-details
                >
                    <template>
                        <v-icon slot="append" color="white">mdi-magnify</v-icon>
                    </template>
                </v-text-field>
            </v-col>
            <v-col cols="4" class="py-0">
                <v-select
                    label="Cluster"
                    outlined
                    dense
                    multiple
                    class="input-cinza"
                    v-model="cluster_tabela"
                    :items="listaClusterTabela"
                    item-value="value"
                    item-text="text"
                    :menu-props="menuProps"
                >
                    <template v-slot:selection="{ item, index }">
                        <span v-if="cluster_tabela.length === 1 && index === 0">{{ item.text }}</span>
                        <span v-if="cluster_tabela.length > 1 && index === 0" class="grey--text caption mr-1">
                            {{ cluster_tabela.length }} selecionados
                        </span>
                    </template>
                </v-select>
            </v-col>
            <v-col cols="4" align="end" class="py-0">
                <v-btn
                    class="new-button px-5"
                    color="yellow"
                    dark
                    @click="limpar()"
                >
                    <v-icon left>mdi-filter-off</v-icon> Limpar
                </v-btn>
                <v-btn
                    class="ml-4 new-button px-5"
                    color="primary"
                    @click="filtrar()"
                >
                    <v-icon left>mdi-filter</v-icon> Filtrar
                </v-btn>
            </v-col>
        </v-row>
        <v-data-table
            :headers="listaHeader"
            :items="listaLojas"
            :search="buscaFilial"
            item-key="id_filial"
            :items-per-page="5"
            :footer-props="{
                'items-per-page-options': [5, 10, 50, 100, 500, -1],
                itemsPerPageText: 'Linhas por páginas',
                ofText: 'de',
                pageText: '{0}-{1} de {2}',
            }"
            :options.sync="pagination"
            class="tabela-filial"
        >
            <template v-slot:header="{}">
                <thead>
                    <tr>
                        <th colspan="6"></th>
                        <th
                            v-for="p in getPeriodo()"
                            :key="p"
                            class="v-data-table-header text-center th-separador top-header"
                        >
                            <div
                                style="width: 24px; margin-left: auto; margin-right: auto; display: block;"
                                class="text-center"
                            >
                                <v-checkbox
                                    :key="p"
                                    v-model="todasFiliais[p]"
                                    @click="selecionaTudo(p)"
                                    color="#fff"
                                    dark
                                    class="ma-0 pa-0"
                                    hide-details
                                />
                            </div>
                        </th>
                    </tr>
                </thead>
            </template>
            <template
                v-for="periodo in listaPeriodo"
                v-slot:[`item.quantidade${periodo}`]="{ item }"
            >
                <v-tooltip bottom :key="periodo" :disabled="temDisponibilidade(item, periodo)">
                    <template v-slot:activator="{ on, attrs }">
                        <div v-bind="attrs" v-on="on">
                            <v-simple-checkbox
                                :ripple="false"
                                :value="item['quantidade' + periodo]"
                                :disabled="!temDisponibilidade(item, periodo)"
                                @input="checkFilial(item, `quantidade${periodo}`, $event)"
                            />
                        </div>
                    </template>
                    <span>Sem espaço disponível para este período</span>
                </v-tooltip>
            </template>
        </v-data-table>

        <v-row no-gutters class="mb-3 mt-1">
            <v-col cols="12" class="px-2 ml-auto" align="end">
                <v-btn
                    class="new-button px-5 mx-2"
                    color="primary"
                    @click="abrirImportacao()"
                >
                    <v-icon left>mdi-upload</v-icon> Importar Base de Filiais
                </v-btn>
                <v-btn
                    class="new-button px-5 mx-2"
                    color="error"
                    @click="limpaSelecionadas(true)"
                >
                    <v-icon left>mdi-trash-can</v-icon> Limpar Filiais
                </v-btn>
                <v-btn
                    class="new-button px-5 mx-2"
                    color="primary"
                    @click="carregarSelecionadas()"
                >
                    <v-icon left>mdi-arrow-up</v-icon> Carregar Filiais Salvas
                </v-btn>
                <v-btn
                    class="new-button px-5 ml-2"
                    color="primary"
                    @click="salvarSelecionadas()"
                >
                    <v-icon left>mdi-arrow-down</v-icon> Salvar Filiais Selecionadas
                </v-btn>
            </v-col>
        </v-row>

        <v-data-table
            :headers="listaHeaderFiliais"
            :items="somaFiliais"
            item-key="nome"
            class="elevation-0 tabela"
            hide-default-footer
            disable-sort
        ></v-data-table>

        <div v-if="dialogoCamposFaltando" class="dialogo-erro" width="700px">
            <v-card class="br-15">
                <v-toolbar elevation="0" dark class="error white--text fix-flex">
                    <v-toolbar-title>
                        Por favor retorne as etapas anteriores e preencha os seguintes campos:
                    </v-toolbar-title>
                </v-toolbar>
                <v-card-text class="pa-5">
                    <v-list>
                        <v-list-item v-for="campo in camposFaltando" :key="campo">
                            <v-list-item-content>
                                <v-list-item-title>{{ campo }}</v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>
                    </v-list>
                </v-card-text>
            </v-card>
        </div>

        <v-overlay :value="carregando" :z-index="300">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
        <v-overlay
            :value="semAcesso"
            :absolute="true"
            :opacity="0.1"
            :z-index="3"
        ></v-overlay>
        <v-overlay
            :value="mostraOverlay"
            :absolute="true"
            :opacity="0.6"
            :z-index="3"
        ></v-overlay>

        <importar-filiais
            ref="importarFiliais"
            @importar="importar"
            @exportarModelo="exportarModelo"
        ></importar-filiais>
    </v-form>
</template>

<script>
import importarFiliais from "./importarFiliais.vue";

export default {
    name: "acordoGCFiliais",
    inject: ["listaCampos"],
    props: ["value"],
    components: {
        importarFiliais,
    },
    data() {
        return {
            carregando: false,
            pagination: {},
            dialogoCamposFaltando: false,
            lista: {
                cluster: [],
            },
            acordo: {},
            filtro: {
                id_cluster: [],
            },
            dados: [],
            buscaFilial: "",
            filiais: [],
            filiaisSalvas: [],
            todasFiliais: [],
            somaFiliais: [],
            semAcesso: false,
            cluster_tabela: [],
            jaCarregou: false,
            menuProps: {
                bottom: true,
                offsetY: true,
                contentClass: "select-outline",
                transition: "slide-y-transition",
            },
        };
    },
    async created() {
    },
    computed: {
        camposFaltando() {
            const campos = [];
            if (!this.value.id_espaco_gc) campos.push("Espaço GC");
            if ((this.value.periodo || []).length === 0) campos.push("Período");
            return campos;
        },
        mostraOverlay() {
            return this.camposFaltando.length > 0;
        },
        filiaisDoAcordo() {
            return new Set(
                (this.value.filiaisAcordo || []).map((f) => f.id_filial)
            );
        },
        listaPeriodo() {
            return this.getPeriodo("");
        },
        listaClusterTabela() {
            const clusters = new Map();
            for (const item of this.dados) {
                if (item.id_cluster && item.cluster && !clusters.has(item.id_cluster)) {
                    clusters.set(item.id_cluster, {
                        text: item.cluster,
                        value: item.id_cluster,
                    });
                }
            }
            return Array.from(clusters.values()).sort((a, b) =>
                (a.text || '').localeCompare(b.text || '')
            );
        },
        listaHeader() {
            var header = [
                { text: "ID JAVA", value: "id_java", align: "center", class: "th-separador" },
                { text: "Estado", value: "estado", align: "center", class: "th-separador" },
                { text: "Filial", value: "nome", align: "center", class: "th-separador" },
                { text: "Cidade", value: "cidade", align: "center", class: "th-separador" },
                { text: "Região", value: "regiao", align: "center", class: "th-separador" },
                { text: "Cluster", value: "cluster", align: "center", class: "th-separador" },
            ];
            for (let mesAtual of (this.value.periodo || [])) {
                mesAtual = new Date(mesAtual + "-15");
                header.push({
                    text:
                        ("0" + (mesAtual.getMonth() + 1)).slice(-2) +
                        "/" +
                        mesAtual.getFullYear(),
                    value:
                        "quantidade_" +
                        mesAtual.getFullYear() +
                        "_" +
                        (mesAtual.getMonth() + 1),
                    align: "center",
                    class: "th-separador",
                });
            }
            return header;
        },
        listaHeaderFiliais() {
            var header = [
                { text: "", value: "nome", align: "center", class: "th-separador" },
                { text: "Total", value: "total", align: "center", class: "th-separador" },
            ];
            for (let mesAtual of (this.value.periodo || [])) {
                mesAtual = new Date(mesAtual + "-15");
                header.push({
                    text:
                        ("0" + (mesAtual.getMonth() + 1)).slice(-2) +
                        "/" +
                        mesAtual.getFullYear(),
                    value:
                        "quantidade_" +
                        mesAtual.getFullYear() +
                        "_" +
                        (mesAtual.getMonth() + 1),
                    align: "center",
                    class: "th-separador",
                });
            }
            return header;
        },
        listaLojas() {
            let _filter = this.dados;
            if (this.cluster_tabela.length > 0) {
                const flatClusters = this.cluster_tabela.flat();
                _filter = _filter.filter((e) => flatClusters.includes(e.id_cluster));
            }
            return _filter;
        },
    },
    methods: {
        getPeriodo(campo = "quantidade") {
            let extraido = [];
            for (var i of (this.value.periodo || [])) {
                extraido.push(
                    campo +
                    "_" +
                    i.substring(0, 4) +
                    "_" +
                    parseInt(i.substring(5, 7))
                );
            }
            return extraido;
        },
        temDisponibilidade(item, periodo) {
            // O espaço das filiais que já estão no acordo em edição é dele: seguem liberadas
            if (this.filiaisDoAcordo.has(item.id_filial)) return true;

            // Extrai o período do campo (ex: quantidade_2026_4 -> oportunidade_2026_04)
            const periodoMatch = periodo.match(/_(\d{4})_(\d+)$/);
            if (!periodoMatch) return false;

            const ano = periodoMatch[1];
            const mes = periodoMatch[2].padStart(2, '0');
            const oportunidade = item[`oportunidade_${ano}_${mes}`];

            return oportunidade !== undefined && oportunidade !== null && oportunidade > 0;
        },
        checkFilial(item, campo, value) {
            this.$set(item, campo, value);
        },
        selecionaTudo(periodo) {
            const value = this.todasFiliais[periodo];
            for (let item of this.listaLojas) {
                // Só seleciona se tiver disponibilidade
                if (this.temDisponibilidade(item, periodo)) {
                    this.$set(item, periodo, value);
                }
            }
        },
        calcularSomaFiliais() {
            const periodos = this.getPeriodo();
            const _clusters = new Set();
            const clustersNoAcordo = new Set();
            let soma = {
                total: 0,
            };
            for (let p of periodos) {
                soma[p] = 0;
            }
            for (let item of this.dados) {
                var fnFilial = 0;
                for (let p of periodos) {
                    if (item[p]) {
                        soma[p]++;
                        fnFilial = 1;
                    }
                }
                if (fnFilial > 0) _clusters.add(item.cluster);
                if (fnFilial > 0) clustersNoAcordo.add(item.id_cluster);
                soma.total += fnFilial;
            }

            soma.nome = `Filiais Salvas (${[..._clusters].join(" / ")})`;
            this.value.clustersNoAcordo = [...clustersNoAcordo];
            this.somaFiliais = [soma];
        },
        async setAcordo() {
            if (this.camposFaltando.length > 0) {
                this.dialogoCamposFaltando = true;
                return;
            }
            this.dialogoCamposFaltando = false;

            this.carregando = true;

            // Salva as seleções atuais antes de recarregar
            const selecoesSalvas = this.salvarSelecoesAtuais();

            try {
                var data = {
                    id_espaco_gc: this.value.id_espaco_gc,
                    periodo: this.value.periodo,
                    clusterRede: this.value.clusterRede,
                };

                if (this.value.fnEditar) {
                    data.id_acordo_gc = this.value.id_acordo_gc;
                }

                var response = await this.$http().post("/acordoGC/filiais", {
                    data: data,
                });

                var result = response.data.result || response.data;
                this.dados = this.inicializarFiliais(Array.isArray(result) ? result : []);
                this.filiais = this.dados;
                
                // Restaura as seleções anteriores se existirem
                this.restaurarSelecoes(selecoesSalvas);
            } catch (error) {
                // Mock data para desenvolvimento
                this.dados = this.gerarMockFiliais();
                this.filiais = this.dados;
            }

            this.calcularSomaFiliais();
            this.jaCarregou = true;
            this.carregando = false;
        },
        salvarSelecoesAtuais() {
            if (!this.dados || this.dados.length === 0) return {};
            
            const selecoes = {};
            const periodos = this.getPeriodo();
            
            for (let item of this.dados) {
                const chave = item.id_filial;
                selecoes[chave] = {};
                for (let p of periodos) {
                    if (item[p]) {
                        selecoes[chave][p] = true;
                    }
                }
            }
            return selecoes;
        },
        restaurarSelecoes(selecoesSalvas) {
            if (!selecoesSalvas || Object.keys(selecoesSalvas).length === 0) return;
            
            for (let item of this.dados) {
                const chave = item.id_filial;
                if (selecoesSalvas[chave]) {
                    for (let periodo in selecoesSalvas[chave]) {
                        // Só restaura se ainda tiver disponibilidade
                        if (this.temDisponibilidade(item, periodo)) {
                            this.$set(item, periodo, true);
                        }
                    }
                }
            }
        },
        inicializarFiliais(filiais) {
            return filiais.map((filial) => {
                const presente =
                    filial.presente_acordo || this.filiaisDoAcordo.has(filial.id_filial);
                for (let mes of (this.value.periodo || [])) {
                    const d = new Date(mes + "-15");
                    const ano = d.getFullYear();
                    const mesNum = d.getMonth() + 1;
                    const key = "quantidade_" + ano + "_" + mesNum;

                    filial[key] = presente && this.temDisponibilidade(filial, key);
                }
                return filial;
            });
        },
        gerarMockFiliais() {
            const estados = ["SP", "RJ", "MG", "PR", "RS"];
            const cidades = ["São Paulo", "Rio de Janeiro", "Belo Horizonte", "Curitiba", "Porto Alegre"];
            const clusters = ["POPULAR", "NOBRE", "HIBRIDA", "SUPER POPULAR", "SUPER NOBRE"];
            const filiais = [];

            for (let i = 0; i < 20; i++) {
                const idx = i % 5;
                let filial = {
                    id_filial: i + 1,
                    id_java: 1000 + i,
                    estado: estados[idx],
                    cidade: cidades[idx],
                    cluster: clusters[idx],
                    id_cluster: idx + 1,
                };
                for (let mes of (this.value.periodo || [])) {
                    const d = new Date(mes + "-15");
                    const key = "quantidade_" + d.getFullYear() + "_" + (d.getMonth() + 1);
                    filial[key] = false;
                }
                filiais.push(filial);
            }
            return filiais;
        },
        filtrar() {
            // Trigger recalc
            this.calcularSomaFiliais();
        },
        limpar() {
            this.cluster_tabela = [];
            this.buscaFilial = "";
        },
        limpaFiltro() {
            this.cluster_tabela = [];
            this.buscaFilial = "";
            this.jaCarregou = false;
        },
        limpaSelecionadas(recalcular = false) {
            const periodos = this.getPeriodo();
            for (let item of this.dados) {
                for (let p of periodos) {
                    this.$set(item, p, false);
                }
            }
            this.todasFiliais = [];
            if (recalcular) this.calcularSomaFiliais();
        },
        salvarSelecionadas() {
            const periodos = this.getPeriodo();
            this.filiaisSalvas = this.dados
                .filter((item) => periodos.some((p) => item[p]))
                .map((item) => ({ ...item }));
            this.calcularSomaFiliais();
            this.$dialog.notify.success(
                `${this.filiaisSalvas.length} filiais salvas com sucesso!`,
                { position: "top-right", timeout: 3000 }
            );
        },
        carregarSelecionadas() {
            if (this.filiaisSalvas.length === 0) {
                this.$dialog.notify.warning("Nenhuma filial salva encontrada.", {
                    position: "top-right",
                    timeout: 3000,
                });
                return;
            }
            const periodos = this.getPeriodo();
            for (let salva of this.filiaisSalvas) {
                const item = this.dados.find((d) => d.id_filial === salva.id_filial);
                if (item) {
                    for (let p of periodos) {
                        this.$set(item, p, salva[p]);
                    }
                }
            }
            this.calcularSomaFiliais();
            this.$dialog.notify.success("Filiais carregadas com sucesso!", {
                position: "top-right",
                timeout: 3000,
            });
        },
        async abrirImportacao() {
            this.limpaFiltro();
            this.$refs.importarFiliais.abrir(this.value, this.dados);
        },
        async importar() {
            this.limpaSelecionadas();
            this.dados = this.$refs.importarFiliais.dados;
            this.salvarSelecionadas();
        },
        async exportarModelo() {
            this.$refs.importarFiliais.carregando = true;

            var data = {};
            data.acordo = this.value;

            try {
                var response = await this.$http().post("/acordoGC/modeloFiliais", {
                    data: data,
                });

                window.location = this.$http("baseURL") + response.data.url;
            } catch (error) {
                this.$dialog.notify.error("Erro ao exportar modelo.", {
                    position: "top-right",
                    timeout: 3000,
                });
            }

            this.$refs.importarFiliais.carregando = false;
        },
        validate() {
            const periodos = this.getPeriodo();
            const temFilial = this.dados.some((item) =>
                periodos.some((p) => item[p])
            );
            return temFilial;
        },
    },
};
</script>

<style scoped>
.v-simple-checkbox:disabled {
    opacity: 0.4;
    cursor: not-allowed;
}

.v-data-table >>> .v-simple-checkbox--disabled {
    opacity: 0.4;
}
</style>
